import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle, Loader } from 'lucide-react';
import teamService from '../services/teamService';
import './AcceptInvitePage.css';

const AcceptInvitePage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('رابط الدعوة غير صالح');
      return;
    }

    const accept = async () => {
      const res = await teamService.acceptInvite(token);
      if (res.success) {
        setStatus('success');
        setMessage('تم قبول الدعوة بنجاح! أنت الآن عضو في الفريق.');
        // Redirect to dashboard after 3 seconds
        setTimeout(() => navigate('/dashboard'), 3000);
      } else {
        setStatus('error');
        setMessage(res.message || 'الدعوة منتهية أو غير صالحة');
      }
    };

    accept();
  }, [token, navigate]);

  return (
    <div className="accept-invite-page" dir="rtl">
      <div className="accept-invite-card">
        <div className="accept-invite-logo">منصة مسك</div>

        {status === 'loading' && (
          <div className="accept-invite-body">
            <Loader size={48} className="spin accept-icon loading-icon" />
            <h2>جاري قبول الدعوة...</h2>
            <p>يرجى الانتظار لحظة</p>
          </div>
        )}

        {status === 'success' && (
          <div className="accept-invite-body">
            <CheckCircle size={48} className="accept-icon success-icon" />
            <h2>تم القبول بنجاح!</h2>
            <p>{message}</p>
            <p className="redirect-note">سيتم تحويلك للوحة التحكم خلال ثوانٍ...</p>
            <button className="btn btn-primary" onClick={() => navigate('/dashboard')}>
              انتقل الآن
            </button>
          </div>
        )}

        {status === 'error' && (
          <div className="accept-invite-body">
            <XCircle size={48} className="accept-icon error-icon" />
            <h2>حدث خطأ</h2>
            <p>{message}</p>
            <button className="btn btn-primary" onClick={() => navigate('/dashboard')}>
              العودة للرئيسية
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AcceptInvitePage;
